/* eslint-disable max-len */
const data = {
    copyright: `${new Date().getFullYear()} MyInvestor`,
};

const phones = {
    comercial1: '910005981',
    comercial2: '900800555',
    mortgages: '917453400',
};

const emails = {
    info: 'info@myinvestor.es',
    mortgages: 'dpo@andbank.es',
    support: 'atencionclienteesp@andbank.es',
    securityPolicy: 'dpo@andbank.es',
};

const rrss = {
    facebook: 'https://www.facebook.com/MyInvestorES/',
    twitter: 'https://twitter.com/MyInvestorES',
    youtube: 'https://www.youtube.com/channel/UCc9nsd1tjDdw32wLcM5OOWQ',
    linkedin: 'https://www.linkedin.com/company/myinvestor/',
    instagram: 'https://www.instagram.com/myinvestores',
    telegram: 'https://t.me/myinvestornews',
    spotify:
        'https://open.spotify.com/show/1wtNYaVyWpEWKVPLrtraoZ?si=rWddTTY7Q2ebU6YJbFG9Rw',
    ivoox: 'https://www.ivoox.com/escuchar-myinvestor_nq_742061_1.html',
};

const urls = {
    web: 'https://myinvestor.es',
    openAccount:
        'https://newapp.myinvestor.es/auth/signup/intro/?data_trigger=Header_cta_Apertura&data_traffic_origin=Web_Blog',
};

const docs = {
    customerPrivacity:
        '/data/pdf/legal/Clausula-Proteccion-de-Datos-Andbank-23_05_2018-CLIENTES.pdf',
    leadPrivacity:
        '/data/pdf/legal/Clausula-Proteccion-de-Datos-Andbank-23_05_2018-POTENCIALES.pdf',
    cookies:
        'https://myinvestor.es/politica-de-cookies/',
};

const logos = {
    desktop: {
        default: '/images/myblog-new-logo.svg',
        invert: '/images/myblog-new-logo-invert.svg',
    },
    mobile: {
        default: '/images/myblog-new-logo.svg',
        invert: '/images/myblog-new-logo-invert.svg',
    },
    web: {
        default: '/images/logo-myinvestor-web.svg',
        invert: '/images/logo-myinvestor-web-invert.svg'
    }
};

const token =
    'a2e8e18ad26a079c576038f0ad4fa18ce0d9e415f5bf6f43f89cf3831a0e4685__';

export default {
    data,
    docs,
    phones,
    emails,
    rrss,
    urls,
    logos,
    token,
};
